<template>
  <fragment>
    <common-header
      subname="프로그램 관리"
      name="프로그램 목록 관리"
      v-bind:searchbox="true"
      v-bind:menus="menus"
      v-bind:buttons="buttons"
      @keywordChanged="keywordChanged"
    ></common-header>

    <section ref="container" class="container">
      <ctrl-category-filter
        listName="강좌 목록"
        @changeCategories="changeCategories"
        @changeFilters="changeFilters"
      ></ctrl-category-filter>

      <div class="container-fiuld">
        <div class="btn-group-box clearfix">
          <div class="btn-group pull-right clearfix">
            <select class="form-control round pull-left m-r-5" v-model="pageSize" @change="refresh">
              <option value="10">10개씩 보기</option>
              <option value="30">30개씩 보기</option>
              <option value="50">50개씩 보기</option>
            </select>
            <select class="form-control round pull-left m-r-5" v-model="orderBy" @change="refresh">
              <option value="REG_DATE ASC">프로그램 등록일 ↑</option>
              <option value="REG_DATE DESC">프로그램 등록일 ↓</option>
              <option value="LEC_NAME">프로그램명 가나다순</option>
            </select>
            <div class="select pull-left m-r-5">
              <a class="btn round pull-left" @click="downloadExcel">
                <img class="v-mid m-r-5" src="images/x.png" alt /> 전체 다운로드
              </a>
            </div>
          </div>
        </div>
        <table class="table2 table-hover m-t-10 text-center">
          <tbody v-for="(lec,index) in classes" :key="'classes-list-'+index+'-'+hash(lec)" @click="selectedClass=lec">
            <tr>
              <td>
                <span class="table-label" v-if="lec.templStreEnable">임시저장</span>
                <img
                  class="round"
                  :src="lec.lecIcon?'/download/'+lec.lecIcon.atchFileId:'http://placehold.it/80x80'"
                  alt
                  width="80"
                />
              </td>
              <td class="text-left" @click.stop.prevent="selectedClass=lec">
                <div class="m-t-10 m-b-10">
                  <!--<span class="label m-r-5" style="background-color: chocolate;">온라인</span>-->
                  {{lec.category}}
                  <br />
                  <span class="f-16">{{lec.lecName}}</span>
                </div>
                <p class="pull-left" v-if="lec.applStartDate">
                  신청기간:
                  <span
                    class="m-l-5 m-r-10 inline"
                  >{{lec.applStartDate}} ~ {{lec.applEndDate?lec.applEndDate:'계속'}}</span>
                </p>
                <p class="pull-left m-l-10" v-if="lec.lecEduDateList&&lec.lecEduDateList.length">
                  교육기간:
                  <span
                    class="m-l-5 inline"
                    v-if="lec.eduPeriodType!='일정 선택'"
                  >{{lec.lecEduDateList[0].eduStartDate}} ~ {{lec.lecEduDateList[lec.lecEduDateList.length-1].eduEndDate?lec.lecEduDateList[lec.lecEduDateList.length-1].eduEndDate:'계속'}}</span>
                  <span
                    class="m-l-5 inline"
                    v-if="lec.eduPeriodType=='일정 선택'"
                  >{{lec.lecEduDateList[0].eduStartDate}} ~ {{lec.lecEduDateList[lec.lecEduDateList.length-1].eduStartDate}}</span>
                </p>
              </td>
              <td>
                <!-- <a
                  class="more m-r-10"
                  :href="'#/classroom/'+lec.lecId+'/curriculum'"
                  target="_blank"
                >강의실</a> -->
                <a
                  class="copy m-r-10"
                  @click="$router.push('/classes/register?copy=true&origin='+lec.lecId)"
                >복사</a>
                <a
                  class="modify m-r-10"
                  @click="$router.push('/classes/register?modify=true&origin='+lec.lecId)"
                >수정</a>
                <a class="del" @click="deleteLec(lec.lecId)">삭제</a>
              </td>
            </tr>
            <tr class="margin">
              <td colspan="3"></td>
            </tr>
          </tbody>
        </table>
        <div v-if="!classes.length" class="text-center">
          개설된 프로그램이 없습니다.
        </div>
        <ctrl-pagination
          :currentPage="offset / pageSize + 1"
          :pageSize="pageSize"
          :totalCount="totalCount"
          :key="hash({pageSize, offset, totalCount})"
          @pageChanged="onPageChanged"
        ></ctrl-pagination>
      </div>
      <ctrl-class-summary :item="selectedClass" ref="scrollableSummary" :key="'classes-summary-'+hash(selectedClass)" v-if="selectedClass" @reload="refresh" @apply="apply"></ctrl-class-summary>
    </section>

    <common-footer></common-footer>

    <modal-new-class
      :config="modals.ModalNewClass"
      @close="modals.ModalNewClass.show=false"
      :key="'modal-new-class-'+hash(modals.ModalNewClass)"
    ></modal-new-class>

    <modal-apply-manual-type-online
      :config="modals.ModalApplyManualTypeOnline"
      @close="modals.ModalApplyManualTypeOnline.show=false;"
      :key="hash(modals.ModalApplyManualTypeOnline)"
      @done="applyManualDone('ModalApplyManualTypeOnline')"
    ></modal-apply-manual-type-online>

    <modal-apply-manual-type-income
      :config="modals.ModalApplyManualTypeIncome"
      @close="modals.ModalApplyManualTypeIncome.show=false;"
      :key="hash(modals.ModalApplyManualTypeIncome)"
      @done="applyManualDone('ModalApplyManualTypeIncome')"
    ></modal-apply-manual-type-income>

    <modal-apply-manual-type-teacher
      :config="modals.ModalApplyManualTypeTeacher"
      @close="modals.ModalApplyManualTypeTeacher.show=false;"
      :key="hash(modals.ModalApplyManualTypeTeacher)"
      @done="applyManualDone('ModalApplyManualTypeTeacher')"
    ></modal-apply-manual-type-teacher>

    <modal-apply-manual-type-outgo
      :config="modals.ModalApplyManualTypeOutgo"
      @close="modals.ModalApplyManualTypeOutgo.show=false;"
      :key="hash(modals.ModalApplyManualTypeOutgo)"
      @done="applyManualDone('ModalApplyManualTypeOutgo')"
    ></modal-apply-manual-type-outgo>

    <modal-apply-manual-type-dream
      :config="modals.ModalApplyManualTypeDream"
      @close="modals.ModalApplyManualTypeDream.show=false;"
      :key="hash(modals.ModalApplyManualTypeDream)"
      @done="applyManualDone('ModalApplyManualTypeDream')"
    ></modal-apply-manual-type-dream>

    <modal-apply-manual-type-ssok
      :config="modals.ModalApplyManualTypeSsok"
      @close="modals.ModalApplyManualTypeSsok.show=false;"
      :key="hash(modals.ModalApplyManualTypeSsok)"
      @done="applyManualDone('ModalApplyManualTypeSsok')"
    ></modal-apply-manual-type-ssok>

    <modal-confirm
      :config="modals.ModalConfirm"
      @yes="modals.ModalConfirm.show=false"
      @no="modals.ModalConfirm.show=false"
      :key="hash(modals.ModalConfirm)"
    ></modal-confirm>
    <modal-alert
      :config="modals.ModalAlert"
      @close="modals.ModalAlert.show=false;"
      :key="hash(modals.ModalAlert)"
    ></modal-alert>
  </fragment>
</template>

<script>
import axios from "axios";
import server from "../statics/server.js";

import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
import fnClassRegister from "../mixins/fnClassRegister.js";
import fnScrollable from "../mixins/fnScrollable.js";
import CommonHeader from "../components/CommonHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
import CtrlCategoryFilter from "../components/CtrlCategoryFilter.vue";
import CtrlClassSummary from '../components/CtrlClassSummary.vue'
import CtrlPagination from "../components/CtrlPagination.vue";

import ModalNewClass from "../modals/ModalNewClass.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";
import ModalAlert from "../modals/ModalAlert.vue";
import ModalApplyManualTypeOnline from "../modals/ModalApplyManualTypeOnline.vue";
import ModalApplyManualTypeIncome from "../modals/ModalApplyManualTypeIncome.vue";
import ModalApplyManualTypeTeacher from "../modals/ModalApplyManualTypeTeacher.vue";
import ModalApplyManualTypeOutgo from "../modals/ModalApplyManualTypeOutgo.vue";
import ModalApplyManualTypeDream from "../modals/ModalApplyManualTypeDream.vue";
import ModalApplyManualTypeSsok from "../modals/ModalApplyManualTypeSsok.vue";

export default {
  name: "ViewClassList",
  mixins: [fnScrollable, fnAdjustHeight, fnClassRegister],

  components: {
    CommonHeader,
    CommonFooter,
    CtrlCategoryFilter,
    CtrlClassSummary,
    CtrlPagination,
    ModalNewClass,
    ModalConfirm,
    ModalAlert,
    ModalApplyManualTypeOnline,
    ModalApplyManualTypeIncome,
    ModalApplyManualTypeTeacher,
    ModalApplyManualTypeOutgo,
    ModalApplyManualTypeDream,
    ModalApplyManualTypeSsok,
  },
  mounted: function() {
    this.refresh();
  },
  watch: {
    orderBy: function() {
      this.refresh();
    },
    pageSize: function() {
      this.refresh();
    }
  },
  data: function() {
    return {
      menus: [
        { name: "프로그램 신청 관리", link: "/classes/apply", selected: false },
        // { name: "수강현황 관리", link: "/classes/progress", selected: false },
        { name: "프로그램 목록 관리", link: "/classes", selected: true }
      ],
      buttons: [
        {
          name: "프로그램 개설",
          fn: () => {
            this.openNewClassModal();
          }
        }
      ],
      modals: {
        ModalNewClass: ModalNewClass.default(),
        ModalConfirm: ModalConfirm.default(),
        ModalAlert: ModalAlert.default(),
        ModalApplyManualTypeOnline: ModalApplyManualTypeOnline.default(),
        ModalApplyManualTypeIncome: ModalApplyManualTypeIncome.default(),
        ModalApplyManualTypeTeacher: ModalApplyManualTypeTeacher.default(),
        ModalApplyManualTypeOutgo: ModalApplyManualTypeOutgo.default(),
        ModalApplyManualTypeDream: ModalApplyManualTypeDream.default(),
        ModalApplyManualTypeSsok: ModalApplyManualTypeSsok.default()
      },
      filterList: [],
      categoryList: [],
      totalCount: 0,
      // 검색 조건
      offset: 0,
      keyword: "",
      orderBy: "REG_DATE DESC",
      pageSize: 10,
      // 강의목록
      classes: [],
      selectedClass: null
    };
  },
  methods: {
    downloadExcel: function() {
      axios
        .post(server.addr() + server.api.LECTURE_EXCEL, {
          offset: 0,
          filterList: this.filterList,
          keyword: this.keyword,
          orderBy: this.orderBy,
          pageSize: 5000000
        })
        .then(response => {
          window.open(server.addr() + "/download/" + response.data, "", "");
        });
    },
    refresh: function(n) {
      axios
        .post(server.addr() + server.api.LECTURE, {
          offset: this.offset,
          filterList: this.filterList,
          categoryList: this.categoryList,
          keyword: this.keyword,
          orderBy: this.orderBy,
          pageSize: this.pageSize
        })
        .then(response => {
          if (response.status == 200 && response.data) {
            this.classes = response.data.list.map(el => {
              if (el.applStartDate) {
                let t = new Date(el.applStartDate);
                el.applStartDate =
                  t.getFullYear() +
                  "-" +
                  ("0" + (t.getMonth() + 1)).slice(-2) +
                  "-" +
                  ("0" + t.getDate()).slice(-2) +
                  " " +
                  ("0" + t.getHours()).slice(-2) +
                  ":" +
                  ("0" + t.getMinutes()).slice(-2);
              }
              if (el.applEndDate) {
                let t = new Date(el.applEndDate);
                el.applEndDate =
                  t.getFullYear() +
                  "-" +
                  ("0" + (t.getMonth() + 1)).slice(-2) +
                  "-" +
                  ("0" + t.getDate()).slice(-2) +
                  " " +
                  ("0" + t.getHours()).slice(-2) +
                  ":" +
                  ("0" + t.getMinutes()).slice(-2);
              }
              el.categoryParent_ = null;
              el.categoryChild_ = null;
              axios
                .post(server.addr() + server.api.CATEGORY + "/" + el.categoryId)
                .then(response => {
                  if (response.data.return && response.data.return.parentsId) {
                    el.categoryChild_ = response.data.return;
                    axios
                      .post(
                        server.addr() +
                          server.api.CATEGORY +
                          "/" +
                          el.categoryChild_.parentsId
                      )
                      .then(response => {
                        el.categoryParent_ = response.data.return;
                      });
                  } else if (response.data.return) {
                    el.categoryParent_ = response.data.return;
                  }
                });
              if(el.lecId==n) this.selectedClass = el;
              return el;
            });
            this.totalCount = parseInt(response.data.filtered);
          } else {
            // eslint-disable-next-line
            console.log(
              "강의목록조회 기대하지 않은 응답코드",
              response.status,
              response.data
            );
          }
        })
        .catch(error => {
          this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
          this.modals.ModalAlert.show = true;
          // eslint-disable-next-line
          console.log("ERROR", error);
        });
    },
    // 필터 리스트
    changeFilters: function(filterList) {
      this.filterList = filterList;
      this.refresh();
    },
    // 카테고리 선택 리스트
    changeCategories: function(categoryList) {
      this.categoryList = categoryList;
      this.refresh();
    },
    // 페이지 이동
    onPageChanged: function(page) {
      this.offset = (page - 1) * this.pageSize;
      this.refresh();
    },
    // 강좌 삭제
    deleteLec: function(lecId) {
      this.modals.ModalConfirm.msg = "강좌를 정말 삭제하시겠습니까?";
      this.modals.ModalConfirm.btnYes.name = "삭제";
      this.modals.ModalConfirm.btnYes.fn = () => {
        axios
          .delete(server.addr() + server.api.LECTURE + "/" + lecId)
          .then(response => {
            response;
            this.refresh();
            this.modals.ModalConfirm.show = false;
          });
      };
      this.modals.ModalConfirm.show = true;
    },
    keywordChanged: function(keyword) {
      this.keyword = keyword;
      this.refresh();
    },
    // 관리자 직권 수강신청 모달 노출
    apply: function(lec, lecId) {
      if(lec.applForm=="온라인") {
        this.modals.ModalApplyManualTypeOnline.lec = lec;
        this.modals.ModalApplyManualTypeOnline.lecId = lecId;
        this.modals.ModalApplyManualTypeOnline.show = true;
      } else if(lec.applForm=="찾아가는 국어문화학교") {
        this.modals.ModalApplyManualTypeOutgo.lec = lec;
        this.modals.ModalApplyManualTypeOutgo.lecId = lecId;
        this.modals.ModalApplyManualTypeOutgo.show = true;
      } else if(lec.applForm=="원내") {
        this.modals.ModalApplyManualTypeIncome.lec = lec;
        this.modals.ModalApplyManualTypeIncome.lecId = lecId;
        this.modals.ModalApplyManualTypeIncome.show = true;
      } else if(lec.applForm=="교사직무연수") {
        this.modals.ModalApplyManualTypeTeacher.lec = lec;
        this.modals.ModalApplyManualTypeTeacher.lecId = lecId;
        this.modals.ModalApplyManualTypeTeacher.show = true;
      } else if(lec.applForm=="우리말 꿈터") {
        this.modals.ModalApplyManualTypeDream.lec = lec;
        this.modals.ModalApplyManualTypeDream.lecId = lecId;
        this.modals.ModalApplyManualTypeDream.show = true;
      } else {
        this.modals.ModalApplyManualTypeSsok.lec = lec;
        this.modals.ModalApplyManualTypeSsok.lecId = lecId;
        this.modals.ModalApplyManualTypeSsok.show = true;
      }
    },
    // 관리자 직권 수강신청 완료
    applyManualDone: function(formName) {
      formName;
      this.modals.ModalAlert.msg = "비회원 수강신청서가 입력되었습니다.";
      this.modals.ModalAlert.show = true;
    }
  }
};
</script>
